import { Action } from 'redux-actions';
import { all, put, select, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { getSparePartSuppliersRequest } from '../../api/SparePart/getSparePartSuppliersQuery';
import { executeSagaRequest } from '../../services';

import { GetSparePartSupplierBySellerIdPayload } from './actionCreators';
import * as types from './actionTypes';
import {
  selectGetSparePartSupplierBySellerIdIsLoading,
  selectGetSparePartSupplierBySellerIdWasLoaded,
} from './selectors';

function* getSparePartSuppliersBySellerIdWorker({
  payload,
}: {
  payload: GetSparePartSupplierBySellerIdPayload;
}): Generator {
  const { sellerId } = payload;

  if (!sellerId) {
    return;
  }

  const isLoading = yield select(
    selectGetSparePartSupplierBySellerIdIsLoading,
    {
      sellerId,
    },
  );
  const wasLoaded = yield select(
    selectGetSparePartSupplierBySellerIdWasLoaded,
    {
      sellerId,
    },
  );

  if (isLoading || wasLoaded) {
    return;
  }

  yield executeSagaRequest(
    types.GET_SPARE_PART_SUPPLIER_BY_SELLER_ID,
    getSparePartSuppliersRequest({ sellerId }),
    { indexer: sellerId },
  );

  yield put(types.GET_SPARE_PART_SUPPLIER_BY_SELLER_ID.end({ sellerId }));
}
function* getSparePartSuppliersBySellerIdWatcher() {
  yield takeEvery<Action<GetSparePartSupplierBySellerIdPayload>>(
    types.GET_SPARE_PART_SUPPLIER_BY_SELLER_ID.BASE,
    getSparePartSuppliersBySellerIdWorker,
  );
}

export default function* sparePartSupplierSaga(): Generator {
  try {
    yield all([getSparePartSuppliersBySellerIdWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
